import React, { useEffect, useState, useContext, useRef } from "react";
import styled from "styled-components";
import constants from "./../../../common/constants";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../../redux";
import { toast } from "../../common/Toast";
import Result from "../../../common/repository/Result";
import { Button, Icon, Image, Input, Modal, Popup, Segment, Header as SemanticHeader, Table } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { io, Socket } from "socket.io-client";
import config from "../../../common/repository/config";
import NotifecationRepo from "../../../common/repository/NotifecationRepo";
import NotificationPopup from "./NotificationPopUp";
import { GlobalContext } from "../../../App";
import LocalStorage from "../../../lib/LocalStorage";
import { setAuth } from "../../../redux/auth/actioncreators";
import { useLocation } from "react-router-dom";
import InvoicePopup from "./InvoicePopup";
import Remarks from "../Header/Remarks"
import InstructionPopup from "./InstructionPopup";

const Container = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.03);
`;

interface Metadata {
  call_date: string;
  call_time: string;
  receiver_name: string;
  receiver_number: string;
  receiver_role: string;
  title: string;
  message: string;
}
const Header = (): JSX.Element => {
  const { Count, setCounts } = useContext<any>(GlobalContext);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [Invoicenotifications, setInvoicenotifications] = useState<any[]>([]);
  const [missedNotifications, setMissedNotifications] = useState<any[]>([]);
  const [missedInvoiceNotifications, setMissedInvoiceNotifications] = useState<any[]>([]);
  const [invoiceNotificationData, setInvoiceNotificationData] = useState<any | null>(null);
  const [notificationError, setNotificationError] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [remarkMessage, setRemarkMessage] = useState('');
  const [missedRemarks, setMissedRemarks] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState<any | null>(null);

  const [dailyStatusNotify, setDailyStatusNotify] = useState<any | null>(null);
  const [dailyStatusModalOpen, setDailyStatusModalOpen] = useState(false);
  const [dailyInputs, setDailyInputs] = useState<{ [key: string]: { date?: string; feedback?: string } }>({});
  const [dailyStatusNotifyList, setDailyStatusNotifyList] = useState<any[]>([]);
  const [closureDateInput, setClosureDateInput] = useState('');
  const [closureDateFeedbackInput, setClosureDateFeedbackInput] = useState('');
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState<any>(null);
  const { totalCount } = Count;
  const notificationRepo = new NotifecationRepo();
  const authState = useSelector((state: AppState) => state.auth);
  const dispatch = useDispatch();
  const user = authState.user;
  const location = useLocation();
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    const socket = io(config.apiBaseURLSocket);
    socketRef.current = socket;

    const handleConnect = async () => {
      console.log('Connected to WebSocket server');
      if (user) {
        console.log(user.getId());
        socket.emit("add", { user_id: user.getId() });
      }
      try {
        await fetchMissedNotifications();
        await fetchMissedInvoiceNotifications();
        await fetchMissedRemarks();
        console.log('Missed notifications fetched successfully');
      } catch (error) {
        console.error('Error fetching missed notifications:', error);
      }
    };


    const handleDisconnect = () => {
      console.log('Disconnected from WebSocket server');
    };

    const handleNotification = (notify: any) => {
      if (!notify) return null;
      console.log('Received notification:', notify);
      if (notify.type === "mrd_request") {
        setNotifications(prevNotifications => [...prevNotifications, notify]);
        setShowPopup(true);
      } else {
        console.log("Unhandled notification type:", notify.type);
      }
    };
    const handleWhatsAppNotifiction = (notify: any) => {
      if (!notify) return null;
      console.log('Received Whatsaappnotification:', notify);
      // if (notify.type === "mrd_request") {
      //   setNotifications(prevNotifications => [...prevNotifications, notify]);
      //   setShowPopup(true);
      // } else {
      //   console.log("Unhandled notification type:", notify.type);
      // }
    };

    const handledailyStatus = (notify: any) => {
      if (!notify) return;

      console.log('Received daily Status:', notify);

      if (notify.type === "case_daily_status") {
        const metadata = notify.metadata;
        const updates = Array.isArray(metadata) ? metadata : [metadata];
        setDailyStatusNotifyList(prev => [...prev, ...updates]);
      } else {
        console.log("Unhandled notification type:", notify.type);
      }
    };

    const handledCaseInstruction = (notify: any) => {
      if (!notify) return;
  
      console.log("*******************:", notify);
  
      setPopupData(notify);
      setPopupOpen(true);
    };

    const invoiceNotifications = (notify: any) => {
      if (!notify) return;
      console.log('Received invoice notification:', notify);
      if (notify.type === "invoice_change") {
        const invoiceData = {
          typeId: notify.type_id || '',
          history_id: notify.history_id || '',
          metadata: notify.metadata || {},
          message: notify.message || '',
          title: notify.title || '',
          type_id: notify.type_id || '',
        };
        setMissedInvoiceNotifications(prev => [...prev, invoiceData]);
        setInvoiceNotificationData(invoiceData);
        setShowPopup(true);
      } else {
        console.log("Unhandled invoice notification type:", notify.type);
      }
    };

    const handleremarksnotifictions = (notify: { type: string; message: any, type_id?: string; user_id?: string }) => {
      if (!notify) return null;
      console.log('Received  Remarks notification:', notify);
      if (notify.type === 'rec_remark') {
        setSelectedNotification(notify);

        console.log(notify, "new remarks notifictons")


        setShowRemarkPopup(true);
      }
    }


    if (socket) {
      socket.on("connect", handleConnect);
      socket.on("notification", handleNotification);
      socket.on("whatsapp_message", handleWhatsAppNotifiction)
      socket.on("notification", handledailyStatus)
      socket.on("notification", handledCaseInstruction)
      socket.on("notification", invoiceNotifications);
      socket.on('disconnect', handleDisconnect);
      socket.on("notification", handleremarksnotifictions);

      // if (user) {
      //   console.log(user.getId());
      //   socket.emit("add", { user_id: user.getId() });
      // }

      return () => {
        socket.off("connect", handleConnect);
        socket.off("disconnect", handleDisconnect);
        socket.off("whatsapp_message", handleWhatsAppNotifiction);

        socket.off("notification", handledailyStatus);
        socket.off("notification", handleNotification);
        socket.off("notification", handledCaseInstruction);
        socket.off("notification", invoiceNotifications);
        socket.off("notification", handleremarksnotifictions);

        socket.disconnect();

        if (socketRef.current === socket) {
          socketRef.current = null;
        }
      };
    }
  }, [user?.getId()]);

  useEffect(() => {
    if (missedNotifications.length > 0) {
      setShowPopup(true);
    }
  }, [missedNotifications]);
  useEffect(() => {
    GetAllCount();
  }, []);


  const handleSubmitFeedback = async (notify: any, index: number) => {
    const caseId = notify.case_id;


    if (!closureDateInput) {
      toast.error("Please select overall closure date.");
      return;
    }

    if (!closureDateFeedbackInput) {
      toast.error("Please enter overall closure feedback.");
      return;
    }


    const dailyStatusItems = notify.daily_status.map((status: any) => {
      const input = dailyInputs[status._id] || {};
      return {
        _id: status._id,
        serviceClosureDate: input.date || '',
        serviceFeedback: input.feedback || '',
      };
    });


    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        toast.error("Authentication token is missing.");
        return;
      }

      const allocatorId = user?.getId();

      const response = await fetch(`${config.apiBaseURL}/case/updateDailyStatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify({
          caseId,
          allocatorId,
          closureDate: closureDateInput,
          closureDateFeedback: closureDateFeedbackInput,
          dailyStatus: dailyStatusItems,
        }),
      });

      const responseData = await response.json();
      if (responseData.success === true) {
        const successMessage =
          responseData.message === "No updates applied"
            ? "Feedback updated successfully"
            : responseData.message || "Feedback updated successfully";
        toast.success(successMessage);
        handleClose(index);
      } else {
        toast.error(responseData.message || "Failed to update feedback");
      }

      return responseData;
    } catch (error) {
      console.error('Error updating feedback:', error);
      toast.error("Something went wrong. Please try again.");
      return false;
    }
  };


  async function GetAllCount() {
    const result = await notificationRepo.getNotifectionAllCount();
    if (result instanceof Result.Success) {
      setCounts((obj: any) => {
        // console.log('obj', ({ ...obj, totalCount: result.data.totalItemCount }));
        return ({ ...obj, totalCount: result.data.totalItemCount })

      })
    } else {
      const message = result.message || "Could not load Count";
      toast.error(message);
    }
  }
  const getNotification = (notify: any) => {
    if (!notify) return null;
    console.log('Received notification:', notify);
    if (notify.type === "mrd_request") {
      setNotifications(prevNotifications => [...prevNotifications, notify]);
      setMissedNotifications([]);
    } else {
      setCounts((obj: any) => {
        let totalCaseCount = obj.totalCount + 1;
        return ({ ...obj, [notify.type]: obj[notify.type] + 1, totalCount: totalCaseCount });
      });
      new Notification(notify.title, { body: notify.message, icon: '', data: notify });
    }
  };
  useEffect(() => {
    if (missedNotifications.length > 0) {
      setShowPopup(true);
    }
  }, [missedNotifications]);
  useEffect(() => {
    if (missedInvoiceNotifications.length > 0) {
      setShowPopup(true);
    }
  }, [missedInvoiceNotifications]);
  const fetchMissedNotifications = async () => {
    if (location.pathname.startsWith('/case/view')) {
      console.log("Skip fetching missed notifications for case view page");
      return;
    }

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error('Authentication token is missing.');
        return;
      }

      const response = await fetch(`${config.apiBaseURL}/notification/missedMrd`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
      });

      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      console.log(`missedData: ${data}`);
      setMissedNotifications(data.data.items || []);
      fetchMissedRemarks();
    } catch (error) {
      setNotificationError(error instanceof Error ? error.message : 'An unknown error occurred');
    }
  };

  const fetchMissedInvoiceNotifications = async () => {
    if (location.pathname.startsWith('/case/view')) {
      console.log("Skipping missed invoice notifications fetch on case view page.");
      return;
    }

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error('Authentication token is missing.');
        toast.error('You are not authenticated.');
        return;
      }

      const response = await fetch(`${config.apiBaseURL}/notification/missedInvoiceChanges`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch missed invoice notifications. Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Missed Invoice Notifications Response:', data);

      if (data?.data?.items?.length > 0) {
        console.log('Missed Invoice Notifications:', data.data.items);
        setMissedInvoiceNotifications(data.data.items);
        setMissedNotifications(data.data.items);
      } else {
        console.log('No missed invoice notifications found.');
        setMissedInvoiceNotifications([]);
      }
    } catch (error) {
      console.error('Error fetching missed invoice notifications:', error);
      toast.error(
        error instanceof Error
          ? error.message
          : 'An unknown error occurred while fetching missed invoice notifications.'
      );
    }
  };

  const fetchMissedRemarks = async () => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error('Authentication token is missing.');
        return;
      }

      const response = await fetch(`${config.apiBaseURL}/notification/missedRecRemark`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
      });

      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      console.log(`Missed Remarks Data:`, data);

      if (data?.data?.items?.length > 0) {
        setSelectedNotification(data.data.items[0]);
        setMissedRemarks(true);
        setShowRemarkPopup(true);
      } else {
        setMissedRemarks(false);
      }
    } catch (error) {
      setNotificationError(error instanceof Error ? error.message : 'An unknown error occurred');
    }
  };

  const handleApprove = async (investigatorId: string, caseId: string, typeId: string) => {
    console.log("Notification approved:", investigatorId, caseId, typeId);
    setNotifications(prevNotifications => prevNotifications.slice(1));
    setInvoiceNotificationData(null);
    setCounts((prevCounts: { totalCount: number; }) => ({
      ...prevCounts,
      totalCount: prevCounts.totalCount - 1,
    }));
  };

  const handleDecline = () => {
    setNotifications(prevNotifications => prevNotifications.slice(1));
    setInvoiceNotificationData(null);
  };

  const onLogout = () => {
    socketRef.current?.emit("logout", {
      user_id: user?.getId(),
    });

    LocalStorage.remove(LocalStorage.KEY_AUTH_TOKEN);
    localStorage.removeItem("caseCounts");

    dispatch(setAuth(null));
  };

  const handleClose = (index: number) => {
    setDailyStatusNotifyList(prev => prev.filter((_, i) => i !== index));
  };

  // UpdateDailyStatus
  const handleDateChange = (id: string, date: string) => {
    setDailyInputs(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        date,
      },
    }));
  };

  const handleFeedbackChange = (id: string, feedback: string) => {
    setDailyInputs(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        feedback,
      },
    }));
  };

  const isTodayOrPast = (inputDate: string): boolean => {
    const today = new Date();
    const selected = new Date(inputDate);
    selected.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return selected <= today;
  };



  return (
    <>
      <div className="notification-popups">
        {user?.getRole().getTitle() === constants.roleTitle.ca && (
          missedNotifications.length > 0 ? (
            missedNotifications.map((notification, index) => (
              <NotificationPopup
                key={`missed-${index}`}
                notificationData={notification}
              />
            ))
          ) :
            (
              notifications.map((notification, index) => (
                <NotificationPopup
                  key={`notif-${index}`}
                  notificationData={notification}
                />
              ))
            )
        )}
      </div>

<>
    {popupData && (
        <InstructionPopup
          open={popupOpen}
          onClose={() => setPopupOpen(false)}
          data={popupData}
        />
      )}
</>

      {dailyStatusNotifyList.map((notify, index) => (
        <Modal
          key={index}
          open={true}
          onClose={() => handleClose(index)}
          size="large"
          closeIcon
        >

          <Modal.Header>📋 {notify.claim_number} - Daily Status</Modal.Header>

          <Modal.Content
            scrolling
            style={{
              background: '#f9f9f9',
              borderRadius: '10px',
              padding: '20px'
            }}
          >
            <h4 style={{ color: '#2185d0' }}>Investigator: {notify.zonal_head_name}</h4>
            <p><strong>Case State:</strong> {notify.case_state}</p>
            <p><strong>Insurance Company:</strong> {notify.insurance_company_name}</p>
            <p><strong>TPA:</strong> {notify.tpa_name}</p>
            <p><strong>Status:</strong> {notify.status_state}</p>

            <h5 style={{ marginTop: '20px' }}>Daily Status Updates</h5>
            <div className="ui relaxed divided list" style={{ marginTop: '10px' }}>
              {notify.daily_status?.map((status: any, idx: number) => {
                const input = dailyInputs[status._id] || {};
                const isEnabled = input.date && isTodayOrPast(input.date);

                return (
                  <div
                    key={idx}
                    className="item"
                    style={{
                      background: '#ffffff',
                      borderRadius: '8px',
                      padding: '20px 25px',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                      marginBottom: '20px'
                    }}
                  >
                    <div className="content">
                      <div className="header" style={{ fontSize: '1.4em', color: '#2185d0', marginBottom: '10px' }}>
                        Servicesssss #{idx + 1}
                      </div>
                      <div className="description" style={{ fontSize: '1.1em', lineHeight: '1.6' }}>
                        <p><strong>Service Type:</strong> {status.service_type}</p>
                        <p><strong>Status:</strong> <span style={{ color: status.service_status === 'Finished' ? '#008000' : '#ff0000', fontWeight: 'bold' }}>{status.service_status}</span></p>
                        <p><strong>Feedback:</strong> {status.service_feedback || '—'}</p>
                        <p><strong>Start Date:</strong> {new Date(status.service_start_date).toLocaleString()}</p>
                        <p><strong>Closure Date:</strong> {status.service_closure_date ? new Date(status.service_closure_date).toLocaleString() : '—'}</p>

                        <div style={{ marginTop: '10px' }}>
                          <label><strong>Select Closure Date:</strong></label>
                          <Input
                            type="date"
                            value={input.date || ''}
                            onChange={(e) => handleDateChange(status._id, e.target.value)}
                            style={{ marginTop: '5px' }}
                          />
                        </div>

                        {isEnabled && (
                          <div style={{ marginTop: '15px' }}>
                            <label><strong>Feedback:</strong></label>
                            <Input
                              placeholder="Enter feedback"
                              value={input.feedback || ''}
                              onChange={(e) => handleFeedbackChange(status._id, e.target.value)}
                              fluid
                              style={{ marginTop: '5px' }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* OVERALL CLOSURE SECTION */}
            <div style={{ marginTop: '30px', background: '#fff', padding: '15px', borderRadius: '8px' }}>
              <h4>Case Closure</h4>
              <div style={{ marginBottom: '10px' }}>
                <label><strong> Closure Date:</strong></label>
                <Input
                  type="date"
                  value={closureDateInput}
                  onChange={(e) => setClosureDateInput(e.target.value)}
                  style={{ marginTop: '5px' }}
                />
              </div>


              <div>
                <label><strong> Closure Feedback:</strong></label>
                <Input
                  placeholder="Enter case-level feedback"
                  value={closureDateFeedbackInput}
                  onChange={(e) => setClosureDateFeedbackInput(e.target.value)}
                  fluid
                  style={{ marginTop: '5px' }}
                />
              </div>
            </div>

            {/* ONE SINGLE SUBMIT BUTTON */}
            <Button
              color="blue"
              floated="right"
              onClick={() => handleSubmitFeedback(notify, index)}
              style={{ marginTop: '30px' }}
            >
              Submit All Feedback
            </Button>
          </Modal.Content>
        </Modal>
      ))}

      <div className="notification-popups">
        {user?.getRole().getTitle() === constants.roleTitle.ao && (
          missedInvoiceNotifications.length > 0 ? (
            missedInvoiceNotifications.map((notification, index) => (
              notification && notification.title ? (
                <InvoicePopup
                  key={`missed-${index}`}
                  invoiceData={notification}
                />
              ) : null
            ))
          ) : (
            notifications.map((notification, index) => (
              notification && notification.title ? (
                <InvoicePopup
                  key={`notif-${index}`}
                  invoiceData={notification}
                />
              ) : null
            ))
          )
        )}
      </div>

      <div>

        {showRemarkPopup && (
          <Remarks
            open={showRemarkPopup || missedRemarks}
            onClose={() => setShowRemarkPopup(false)}
            remark={remarkMessage}
            typeId={selectedNotification.type_id || "defaultTypeId"}
            userId={user?.getId() || ""}
            metadata={selectedNotification.metadata}
            title={selectedNotification.title || "Default Title"}
            message={selectedNotification.message}

          />
        )}


      </div>

      <Container style={{ backgroundColor: "#FF6600", color: "white" }}>
        <div style={{ width: `${constants.sidebarWidth}px` }}>
          <strong style={{ fontSize: "20px" }}>{user && user.getName()}</strong>
          <br />
          {user && user.getRole().getTitle()}
        </div>

        <div style={{ flex: 1, textAlign: "center" }}>
          <h1 style={{ color: "white", margin: "0px", fontSize: "32px" }}>Claims Deck</h1>
        </div>

        <div style={{ margin: "0 16px" }}>
          {(user?.getRole().getTitle() === constants.roleTitle.admin ||
            user?.getRole().getTitle() === constants.roleTitle.ca) && (
              <>
                {totalCount > 0 && (
                  <span
                    style={{
                      position: "relative",
                      right: "-18px",
                      background: "red",
                      padding: "5px 10px",
                      borderRadius: "50%",
                    }}
                  >
                    {totalCount <= 1000 ? totalCount : "1000+"}
                  </span>
                )}
                <Popup
                  basic
                  on="click"
                  trigger={
                    <Icon name="bell" size="big" style={{ fontSize: "3em", cursor: "pointer" }} />
                  }
                >
                  <Segment.Group>
                    <Segment>
                      <Link to="/notification">Notifications</Link>
                    </Segment>
                  </Segment.Group>
                </Popup>{" "}
              </>
            )}

          <Popup
            basic
            on="click"
            trigger={
              <Image
                avatar
                src={user && user.getProfilePicURL()}
                style={{ height: "4em", width: "4em" }}
              />
            }
          >
            <Segment.Group>
              <Segment>
                <SemanticHeader as="h4">
                  <SemanticHeader.Subheader>{user?.getName()}</SemanticHeader.Subheader>
                </SemanticHeader>
              </Segment>

              <Segment>
                <Link to="/profile">Update Profile</Link>
              </Segment>

              <Segment>
                <Button color="red" onClick={onLogout}>
                  Logout
                </Button>
              </Segment>
            </Segment.Group>
          </Popup>
        </div>
      </Container>
    </>
  );
};

export default Header;
